import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const SamplePreservationMethodList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="samplePreservationMethod"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default SamplePreservationMethodList;
